import { Cabinet } from 'src/components/cabinet/cabinet';
import { authorized } from '../hocs';

export const CabinetPage = authorized()(() => <Cabinet />);
